import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MatPaginatorTraducao extends MatPaginatorIntl {
  constructor(
    private translate: TranslateService
  ) {
    super();
    this.updatePaginatorTexts();
    this.translate.onLangChange.subscribe(_ => this.updatePaginatorTexts());
  }

  updatePaginatorTexts(): void {
    this.translate.get('SHARED.TABLE.PAGINATOR', { value: 'world' }).subscribe(res => {
      this.itemsPerPageLabel = res.TEXT;
      this.nextPageLabel = res.NEXT_PAGE;
      this.previousPageLabel = res.PREVIOUS_PAGE;
      this.firstPageLabel = res.FIRST_PAGE;
      this.lastPageLabel = res.LAST_PAGE;
    });
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} – ${endIndex} de ${length}`;
  }
}
